import {
  anUpdateInsightStatusInProgressEnabled,
  mockUpdateInsightInProgressStatusOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const ERROR_MESSAGE = 'The "In Progress" status cannot be disabled';

export const updateInsightInProgressMutation_error =
  mockUpdateInsightInProgressStatusOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        errors: [
          {
            message: ERROR_MESSAGE,
          },
        ],
      });
    }
  );

export const handlers = [
  mockUpdateInsightInProgressStatusOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateInsightStatusInProgressEnabled:
            anUpdateInsightStatusInProgressEnabled({ ok: true }),
        },
      });
    }
  ),
];
